import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { map } from "lit/directives/map.js";
import { TFilterItem } from "./learningcenterfilters";

@customElement("learningcenter-filter")
export class LearningCenterFilter extends LitElement {
  @property()
  accessor dictionary: any = {};
  @property()
  accessor items: TFilterItem[] = [];
  @property()
  accessor filterName: string = "";

  @property()
  accessor title: string = "";

  guid = "";

  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.guid = this.generateGUID();
  }

  generateGUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0; // Generate random number between 0 and 15
        const v = c === "x" ? r : (r & 0x3) | 0x8; // Determine the value for x or y
        return v.toString(16); // Convert to hexadecimal
      }
    );
  }

  render() {
    return html`
      <div class="relative ${this.items.length === 0 ? "hidden" : ""}">
        <button
          id="dropdownBgHoverButton_${this.guid}"
          data-dropdown-toggle="dropdownBgHover_${this.guid}"
          data-dropdown-placement="bottom"
          data-dropdown-offset-skidding="0px"
          data-dropdown-offset-distance="-2px"
          class="p text-darker-blue-100 border-darker-blue-100 border-1 bg-medium-grey-10 
          w-full px-2.5 py-3 md:px-6 md:py-2
          rounded-xs text-center flex items-center justify-between gap-2"
          type="button"
        >
          ${this.title}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="9"
            viewBox="0 0 20 9"
            fill="none"
          >
            <path d="M1 1L10 7.73684L19 1" stroke="currentColor" />
          </svg>
        </button>

        <div
          id="dropdownBgHover_${this.guid}"
          class="z-10 hidden w-full 
           bg-medium-grey-10 rounded-b-xs dark:bg-gray-700
          border-darker-blue-100 border-x-1 border-b-1 
          max-h-[400px] overflow-y-auto
          "
        >
          <ul
            class="flex flex-col gap-4 p-2.5 md:p-6"
            aria-labelledby="dropdownBgHoverButton_${this.guid}"
          >
            ${map(
              this.items,
              (item, index) =>
                html`<li>
                  <div class="flex items-center gap-2">
                    <label
                      for="${this.guid}-checkbox-item-${index}"
                      class="w-full p cursor-pointer"
                      >${item.value}</label
                    >
                    <input
                      name="${this.filterName}"
                      id="${this.guid}-checkbox-item-${index}"
                      type="checkbox"
                      value="${item.key}"
                      ?checked="${item.checked}"
                      class="w-4 h-4 text-blue-600 bg-transparent border-darker-blue-100  "
                    />
                  </div>
                </li>`
            )}
          </ul>
          <div class="sticky bottom-0 left-0 bg-medium-grey-10 pb-2.5 px-2.5 md:pb-6 md:px-6">
            <button type="submit" class="button button-navigation  w-full !min-w-0">
              ${JSON.parse(this.dictionary)["apply"] ?? ""}
            </button>
          </div>
        </div>
      </div>
    `;
  }
}
